<template>
    <NavigationButton class="user-avatar" :text="content" />
</template>
<script setup>
import NavigationButton from './navigation-button.vue'

import { computed } from 'vue'
import { jwt } from '@/utils/jwt.js'

const props = defineProps({
    value: {
        type: String,
        default: '',
    },
})

const initials = computed(() => jwt.firstName[0] + jwt.lastName[0])
const content = computed(() => props.value || initials.value)
</script>
<style>
/* todo: color should be dynamic */
.user-avatar.navigation-button {
    background-color: rgba(255, 127, 0, 1);
    color: var(--color-light-text);
}
</style>
